import {getMethod, putMethod} from '@/api'

export const getMappingTable = async (productId, channelManager) =>
    await getMethod(`/api/channelManagerSynchronization/${productId}/${channelManager}`)

export const saveMappingTable = async data =>
    await putMethod('/api/channelManagerSynchronization', data)
